import popular1 from '../_assets/images/popular1.jpg';
import popular2 from '../_assets/images/popular2.jpg';
import popular3 from '../_assets/images/popular3.jpg';
import popular4 from '../_assets/images/popular4.jpg';
import commentUserImg from '../_assets/images/commentUserImg.jpg';
import breakfast1 from '../_assets/images/breakfast1.jpg';
import breakfast2 from '../_assets/images/breakfast2.jpg';
import breakfast3 from '../_assets/images/breakfast3.jpg';
import breakfast4 from '../_assets/images/breakfast4.jpg';
import breakfast5 from '../_assets/images/breakfast5.jpg';
import brunch1 from '../_assets/images/brunch1.jpg';
import brunch2 from '../_assets/images/brunch2.jpg';
import lunch1 from '../_assets/images/lunch1.jpg';
import lunch2 from '../_assets/images/lunch2.jpg';
import lunch3 from '../_assets/images/lunch3.jpg';
import lunch4 from '../_assets/images/lunch4.jpg';
import lunch5 from '../_assets/images/lunch5.jpg';
import lunch6 from '../_assets/images/lunch6.jpg';
import coffee1 from '../_assets/images/coffee1.jpg';
import coffee2 from '../_assets/images/coffee2.jpg';
import coffee3 from '../_assets/images/coffee3.jpg';
import coffee4 from '../_assets/images/coffee4.jpg';
import coffee5 from '../_assets/images/coffee5.jpg';
import coffee6 from '../_assets/images/coffee6.jpg';
// import cupCake from '../_assets/images/cupcake.jpg';
// import breakfast1 from '../_assets/images/breakfast1.jpg';
// import brunch1 from '../_assets/images/brunch1.jpg';
// import lunch1 from '../_assets/images/lunch1.jpg';
// import popular3 from '../_assets/images/popular3.jpg';
import coffee from '../_assets/images/catCoffee.jpg';
import chocolate from '../_assets/images/chocolate.jpg';
import classic from '../_assets/images/classic.jpg';
import herbal from '../_assets/images/herbal.jpg';
import whyTea from '../_assets/images/whyTea.jpg';
import yellowTea from '../_assets/images/yellowTea.jpg';
import greenTea from '../_assets/images/greenTea.jpg';
import oolongTea from '../_assets/images/oolongTea.jpg';
import blackTea from '../_assets/images/blackTea.jpg';
import whiteTea from '../_assets/images/whiteTea.jpg';
import journey from '../_assets/images/journey.jpg';

export const roles = [
   {label: 'Select Role', val: 0},
   {label: 'Super Administrator', val: 1},
   {label: 'Administrator', val: 2},
   {label: 'Company', val: 3},
];

export const menu = [
   {val: 1, to: '/', label: 'home', activeCode: 1},
   {val: 2, to: '/about', label: 'about us', activeCode: 2},
   {val: 3, to: '/menu', label: 'our menu', activeCode: 3},
   {val: 4, to: '/blog', label: 'blog', activeCode: 4},
   {val: 5, to: '/contact', label: 'contact us', activeCode: 5},
];

export const popularDishes = [
   {id: 0, img: popular1, title: 'Nigerian Fare', desc: 'desc', price: '4,500'},
   {id: 1, img: popular2, title: 'English Breakfast', desc: '', price: '5,000'},
   {id: 2, img: popular3, title: 'LTH Breakfast', desc: '', price: '5,500'},
   {id: 3, img: popular4, title: 'Chicken Club Sandwich', desc: '', price: '5,500'},
   {id: 4, img: popular1, title: 'Nigerian Fare', desc: '', price: '4,500'},
   {id: 5, img: popular2, title: 'English Breakfast', desc: '', price: '5,000'},
   {id: 6, img: popular3, title: 'LTH Breakfast', desc: '', price: '5,500'},
   {id: 7, img: popular4, title: 'Chicken Club Sandwich', desc: '', price: '5,500'},
];

export const relatedDishes = [
   {id: 4, img: popular4, title: 'Chicken Club Sandwich', desc: '', price: '5,500'},
   {id: 2, img: popular2, title: 'English Breakfast', desc: '', price: '5,000'},
   {id: 1, img: popular1, title: 'Nigerian Fare', desc: 'desc', price: '4,500'},
   {id: 3, img: popular3, title: 'LTH Breakfast', desc: '', price: '5,500'},
   {id: 5, img: popular1, title: 'Nigerian Fare', desc: '', price: '4,500'},
   {id: 6, img: popular2, title: 'English Breakfast', desc: '', price: '5,000'},
   {id: 7, img: popular3, title: 'LTH Breakfast', desc: '', price: '5,500'},
   {id: 8, img: popular4, title: 'Chicken Club Sandwich', desc: '', price: '5,500'},
];

export const categories = [
   {
      id: 1,
      img: breakfast1,
      label: 'breakfast meals',
      noOfItem: '5',
      contents: [
         {
            id: 0,
            img: breakfast1,
            title: 'LTH Breakfast',
            price: '5,500',
            desc: 'two eggs, two waffles, two pancakes & Bacon sausages',
         },
         {
            id: 1,
            img: breakfast2,
            title: 'English Breakfast',
            price: '5,000',
            desc: 'scrambled eggs, toast grill...',
         },
         {
            id: 2,
            img: breakfast3,
            title: 'Nigerian Fare',
            price: '4,500',
            desc: 'with vegetable sauce choice of fried or bo...',
         },
         {
            id: 3,
            img: breakfast4,
            title: 'Olives Breakfast',
            price: '4,000',
            desc: 'two hard boiled eggs, olives,...',
         },
         {
            id: 4,
            img: breakfast5,
            title: 'Avocado Toast',
            price: '3,500',
            desc: 'toast bread and chefs avocado paste.',
         },
      ],
   },
   {
      id: 2,
      img: brunch2,
      label: 'brunch meals',
      noOfItem: '5',
      contents: [
         {
            id: 0,
            img: brunch1,
            title: 'Chicken club sandwich',
            price: '5,500',
            desc: 'cheese vegetables chicke...',
         },
         {
            id: 1,
            img: brunch2,
            title: 'Veggie Wrap',
            price: '5,000',
            desc: 'Lettuce, cucumber, carrot, b...',
         },
         {
            id: 2,
            // img: cupCake,
            title: 'Tuna Sandwich',
            price: '5,000',
            desc: 'Tuna, Celery, lemon juice, onion, sliced to...',
         },
         {
            id: 3,
            // img: cupCake,
            title: 'Salmon Sandwich',
            price: '8,000',
            desc: 'Bacon, lettuce, tomato, olive...',
         },
         {
            id: 4,
            // img: cupCake,
            title: 'Egg Sandwich',
            price: '4,000',
            desc: 'Egg, toast bread, shredded carrot, shr...',
         },
      ],
   },
   {
      id: 3,
      img: lunch1,
      label: 'lunch meals',
      noOfItem: '6',
      contents: [
         {
            id: 0,
            img: lunch1,
            title: 'Pan Seared Salmon',
            price: '14,000',
            desc: 'salmon fish, lemon, vegetab...',
         },
         {
            id: 1,
            img: lunch2,
            title: 'T-BONE Steak',
            price: '12,000',
            desc: 'T-BONE Steak, vegetables, ...',
         },
         {
            id: 2,
            img: lunch3,
            title: 'Grilled Lamb chops',
            price: '10,000',
            desc: 'cucumber, carrot, creme su...',
         },
         {
            id: 3,
            img: lunch4,
            title: 'Grilled Chicken',
            price: '7,500',
            desc: 'Jollof rice or Fried rice with ...',
         },
         {
            id: 4,
            img: lunch5,
            title: 'Grilled Fish',
            price: '8,500',
            desc: 'Jollof rice or fried rice with sauteed gre...',
         },
         {
            id: 5,
            img: lunch6,
            title: 'Chicken Stir Fry Noodles',
            price: '5,500',
            desc: 'BBW, or spicey chicken wing...',
         },
      ],
   },
   {
      id: 4,
      img: coffee,
      label: 'coffee',
      noOfItem: '8',
      contents: [
         {
            id: 0,
            img: coffee1,
            title: 'Double Expresso',
            price: '1,500',
            // desc: '...',
         },
         {
            id: 1,
            img: coffee2,
            title: 'Expresso',
            price: '1,000',
            // desc: '...',
         },
         {
            id: 2,
            img: coffee3,
            title: 'AMERICANO',
            price: '1,600',
            // desc: '...',
         },
         {
            id: 3,
            img: coffee4,
            title: 'CLASSIC COFFEE',
            price: '1,500',
            // desc: '...',
         },
         {
            id: 4,
            img: coffee5,
            title: 'LATTE MACCHIATO',
            price: '1,700',
            // desc: '...',
         },
         {
            id: 5,
            img: coffee6,
            title: 'FLAT WHITE COFFEE',
            price: '1,500',
            // desc: '...',
         },
         {
            id: 6,
            // img: cupCake,
            title: 'LIGHT COFFEE',
            price: '1,400',
            // desc: '...',
         },
         {
            id: 7,
            // img: cupCake,
            title: 'RISTRETTO',
            price: '1,800',
            // desc: '...',
         },
      ],
   },
   {
      id: 5,
      img: chocolate,
      label: 'hot chocolate',
      noOfItem: '4',
      contents: [
         {
            id: 0,
            // img: cupCake,
            title: 'Rich Chocolate',
            price: '2,200',
            // desc: '...',
         },
         {
            id: 1,
            // img: cupCake,
            title: 'Mashmallow',
            price: '2,000',
            // desc: '...',
         },
         {
            id: 2,
            // img: cupCake,
            title: 'Milk Chocolate',
            price: '2,000',
            // desc: '...',
         },
         {
            id: 3,
            // img: cupCake,
            title: 'Low Calorie Milk Chocolate',
            price: '2,200',
            // desc: '...',
         },
      ],
   },
   {
      id: 6,
      img: classic,
      label: 'tea classic',
      noOfItem: '56',
      contents: [
         {
            id: 0,
            // img: cupCake,
            title: 'TUMERIC FANTRA CHAI',
            price: '2,800',
            desc: '(Caffeine Free)',
         },
         {
            id: 1,
            // img: cupCake,
            title: 'MOROCAN MINT',
            price: '2,800',
            desc: '(Low Caffeine)',
         },
         {
            id: 2,
            // img: cupCake,
            title: 'CARAMEL NOUGAT',
            price: '2,600',
            desc: '(High Caffeine)',
         },
         {
            id: 3,
            // img: cupCake,
            title: 'ESTATE DARJEELING',
            price: '2,500',
            desc: '(High Caffeine)',
         },
         {
            id: 4,
            // img: cupCake,
            title: 'RADIANCE TEA',
            price: '2,800',
            // desc: '',
         },
         {
            id: 5,
            // img: cupCake,
            title: 'DECAF BREAKFAST TEA',
            price: '2,500',
            desc: '(Caffeine Free)',
         },
         {
            id: 6,
            // img: cupCake,
            title: 'ENGLISH BREAKFAST',
            price: '2,500',
            desc: '(High Caffeine)',
         },
         {
            id: 7,
            // img: cupCake,
            title: 'GINEGR LEMON GRASS',
            price: '2,600',
            desc: '(Caffeine Free)',
         },
         {
            id: 8,
            // img: cupCake,
            title: 'JASMINE GREEN TEA',
            price: '2,700',
            desc: '(Caffeine Free)',
         },
         {
            id: 9,
            // img: cupCake,
            title: 'AFRICAN SOLSTICE',
            price: '2,600',
            desc: '(Caffeine Free)',
         },
         {
            id: 10,
            // img: cupCake,
            title: 'CHAMOMILE CITRON',
            price: '3,000',
            desc: '(Caffeine Free)',
         },
         {
            id: 11,
            // img: cupCake,
            title: 'BELGIAN MINT',
            price: '3,000',
            desc: '(Low Caffeine)',
         },
         {
            id: 12,
            // img: cupCake,
            title: 'ORANGE JASMINE',
            price: '2,500',
            desc: '(High Caffeine)',
         },
         {
            id: 13,
            // img: cupCake,
            title: 'MOJITO MARMALADE',
            price: '2,500',
            desc: '(Caffeine Free)',
         },
         {
            id: 14,
            // img: cupCake,
            title: 'CITRUS MINT',
            price: '2,500',
            desc: '(Caffeine Free)',
         },
         {
            id: 15,
            // img: cupCake,
            title: 'MOUNTAIN OOLONG',
            price: '2,800',
            desc: '(Caffeine Free)',
         },
         {
            id: 16,
            // img: cupCake,
            title: 'VANILLA PEAR',
            price: '3,000',
            desc: '(Low Caffeine)',
         },
         {
            id: 17,
            // img: cupCake,
            title: 'CHERRY BLOSSOM',
            price: '2,800',
            desc: '(High Caffeine)',
         },
         {
            id: 18,
            // img: cupCake,
            title: 'STRAWBERRY HIBISCUS',
            price: '2,700',
            desc: '(High Caffeine)',
         },
         {
            id: 19,
            // img: cupCake,
            title: 'ICE BLUEBERRY MERLOT',
            price: '2,200',
            // desc: '',
         },
         {
            id: 20,
            // img: cupCake,
            title: 'ICED GINGER PEAR',
            price: '2,200',
            // desc: '',
         },
         {
            id: 21,
            // img: cupCake,
            title: 'ICED BLOOD ORANGE',
            price: '2,200',
            // desc: '',
         },
         {
            id: 22,
            // img: cupCake,
            title: 'ICED RASPBERRY NECTAR',
            price: '2,200',
            // desc: '',
         },
         {
            id: 23,
            // img: cupCake,
            title: 'WHITE AMBROSIA',
            price: '2,800',
            desc: '(High Caffeine)',
         },
         {
            id: 24,
            // img: cupCake,
            title: 'WHITE GINGER PEAR',
            price: '2,800',
            desc: '(Low Caffeine)',
         },
         {
            id: 25,
            // img: cupCake,
            title: 'FORMOSA OOLONG',
            price: '3,600',
            desc: '(Very High Caffeine)',
         },
         {
            id: 26,
            // img: cupCake,
            title: 'WHITE AYURVEDIC FLAVORED TEA',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 27,
            // img: cupCake,
            title: 'JASMINE SILVER NEEDLE',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 28,
            // img: cupCake,
            title: 'LAVENDER DREAMS',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 29,
            // img: cupCake,
            title: 'PRECIOUS PEACH',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 30,
            // img: cupCake,
            title: 'WATERMELON MINT',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 31,
            // img: cupCake,
            title: 'BODY AND MIND',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 32,
            // img: cupCake,
            title: 'SILVER NEEDLE',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 33,
            // img: cupCake,
            title: 'SILVER YHIN ZHEN PEARLS',
            price: '2,800',
            // desc: '(High Caffeine)',
         },
         {
            id: 34,
            // img: cupCake,
            title: 'PEACH MOMOTARO BLOOMING TEA',
            price: '2,800',
            // desc: '(High Caffeine)',
         },
         {
            id: 35,
            // img: cupCake,
            title: 'JADE CITRUS',
            price: '2,200',
            // desc: '(High Caffeine)',
         },
         {
            id: 36,
            // img: cupCake,
            title: 'SAKURA ALLURE',
            price: '2,200',
            // desc: '(High Caffeine)',
         },
         {
            id: 37,
            // img: cupCake,
            title: 'JASMINE DRAGON PHOENIX PEARLS',
            price: '2,200',
            // desc: '(High Caffeine)',
         },
         {
            id: 38,
            // img: cupCake,
            title: 'BLACK BERRY MOJITO',
            price: '2,200',
            // desc: '(High Caffeine)',
         },
         {
            id: 39,
            // img: cupCake,
            title: 'JAPANESE IMPERIAL MATCHA',
            price: '2,800',
            // desc: '(High Caffeine)',
         },
         {
            id: 40,
            // img: cupCake,
            title: 'JASMINE OOLONG TEA',
            price: '2,400',
            // desc: '(High Caffeine)',
         },
         {
            id: 41,
            // img: cupCake,
            title: 'SWEET ASIAN PEARL',
            price: '2,200',
            // desc: '(High Caffeine)',
         },
         {
            id: 42,
            // img: cupCake,
            title: 'MAHARAJA CHAI/SAMURAI CHI BLEND',
            price: '2,500',
            // desc: '(High Caffeine)',
         },
         {
            id: 43,
            // img: cupCake,
            title: "OPRAH'S MAHARAJA CHAI OOLONG TEA",
            price: '2,500',
            // desc: '(High Caffeine)',
         },
         {
            id: 44,
            // img: cupCake,
            title: 'WONDER BERRY CHOCOLATE',
            price: '2,500',
            // desc: '(High Caffeine)',
         },
         {
            id: 45,
            // img: cupCake,
            title: 'STRAWBERRY ROSE CHAMPAGNE TEA',
            price: '2,500',
            // desc: '(High Caffeine)',
         },
         {
            id: 46,
            // img: cupCake,
            title: 'MONKEY PICKED OOLONG TEA',
            price: '2,800',
            // desc: '(High Caffeine)',
         },
         {
            id: 47,
            // img: cupCake,
            title: 'ORGANIC CARDAMOM TEA',
            price: '1,500',
            desc: '(House Special)',
         },
         {
            id: 48,
            // img: cupCake,
            title: 'CHAI YEN THAI',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 49,
            // img: cupCake,
            title: 'ORIGINAL AROMA RAW PU-ERH (2001)',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 50,
            // img: cupCake,
            title: 'YUNNAN GOLDEN RAW PU-ERH (2004)',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 51,
            // img: cupCake,
            title: 'SAMURAI CHAI MATE',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 52,
            // img: cupCake,
            title: 'CNPP AGED PU-ERH TEA (1990)',
            price: '2,500',
            // desc: '(House Special)',
         },
         {
            id: 53,
            // img: cupCake,
            title: 'MANGO MATE PU-ERH',
            price: '2,500',
            // desc: '(House Special)',
         },
         {
            id: 54,
            // img: cupCake,
            title: 'GOLDEN MONKEY',
            price: '2,500',
            // desc: '(House Special)',
         },
         {
            id: 55,
            // img: cupCake,
            title: 'BLACK DRAGON PEARLS',
            price: '2,500',
            // desc: '(House Special)',
         },
         {
            id: 56,
            // img: cupCake,
            title: 'SAKURA ALLURE',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 57,
            // img: cupCake,
            title: 'JASMINE DRAGON PHOENIX PEARLS',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 58,
            // img: cupCake,
            title: 'BLACK BERRY MOJITO',
            price: '2,200',
            // desc: '(House Special)',
         },
         {
            id: 59,
            // img: cupCake,
            title: 'JAPANESE IMPERIAL MATCHA',
            price: '2,800',
            // desc: '(House Special)',
         },
         {
            id: 60,
            // img: cupCake,
            title: 'JASMINE OOLONG TEA',
            price: '2,400',
            // desc: '(House Special)',
         },
         {
            id: 61,
            // img: cupCake,
            title: 'SWEET ASIAN PEARL',
            price: '2,200',
            // desc: '(House Special)',
         },
      ],
   },
   {
      id: 7,
      img: herbal,
      label: 'herbal tea',
      noOfItem: '4',
      contents: [
         {
            id: 0,
            // img: cupCake,
            title: 'HONEY BUSH VANILLA',
            price: '2,000',
            // desc: '...',
         },
         {
            id: 1,
            // img: cupCake,
            title: 'CARAMEL ALMOND AMARETTI',
            price: '2,000',
            // desc: '...',
         },
         {
            id: 2,
            // img: cupCake,
            title: 'CITRUS LAVENDER SAGE',
            price: '2,000',
            // desc: '...',
         },
         {
            id: 3,
            // img: cupCake,
            title: 'DRAGON FRUIT DEVOTION',
            price: '2,200',
            // desc: '...',
         },
      ],
   },
];

// export const ourMenu = [
//    {id: 0, img: cupCake, title: 'title', desc: 'desc', price: 'price'},
//    {id: 1, img: cupCake, title: 'title', desc: 'desc', price: 'price'},
//    {id: 2, img: cupCake, title: 'title', desc: 'desc', price: 'price'},
// ];

export const blogPost = [
   {
      id: 1,
      img: whyTea,
      title: 'WHY TEA?',
      post: 'Tea is the most consumed drink in the world only after water. Its health properties are medicinal and refreshing. Whether Green, Black, White, Yellow or Oolong Tea, they all come from same type of Tree known as Camellia sinensis. The harvesting and processing time determine the type of Tea. The origin of Teas could be traced back to Asia which has successfully used Teas to treat certain ailments for centuries. They also believe that Tea drinking is plays a major role in their longevity and youthfulness.',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
   {
      id: 2,
      img: yellowTea,
      title: 'YELLOW TEA',
      post: 'Yellow Tea has a mild flavor with less grassy taste than green tea. This tea is the most expensive because the process is more stringent and time consuming. Yellow Tea is also rare to find outside of China. It boasts of its high polyphenols and Catechins which are excellent for overall health and well-being, tackling free radicals and oxidative stress. Yellow tea is also good for Weight Watchers.',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
   {
      id: 3,
      img: greenTea,
      title: 'GREEN TEA',
      post: 'Green Tea has been used in traditional Chinese medicine for centuries to treat everything from headaches to depression. Weight watchers report exciting results from consuming this Tea. The leaves are supposedly richer in antioxidants than other types of tea because of the way they are processed. Green Tea contains B vitamins, Folate (naturally occurring folic acid), manganese, potassium, magnesium, caffeine and other antioxidants notably Catechins.',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
   {
      id: 4,
      img: oolongTea,
      title: 'OOLONG TEA',
      post: 'Health benefits of Oolong Tea include the reduction of chronic health conditions such as heart disease, inflammation and high cholesterol levels, while providing vital antioxidants, promotes superior bone structure, robust skin and good dental health. Oolong Tea is fragrant with a fruity flavor and a pleasant aroma. Despite its caffeine content, it can still be extremely relaxing.',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
   {
      id: 5,
      img: blackTea,
      title: 'BLACK TEA',
      post: 'The health benefits of Black Tea have been well documented for quite some time. What distinguishes Black Teas from the rest is its high oxidation process which accounts for a lot more flavor and high caffeine.',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
   {
      id: 6,
      img: whiteTea,
      title: 'WHITE TEA',
      post: 'White Tea contains the same types of antioxidants as green tea but in greater quantity. These antioxidants are found to have many health promoting properties including boosting Cardiovascular health, helping to lower cholesterol, reducing the risk of Cancer and enhancing Weight Loss.',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
   {
      id: 7,
      img: journey,
      title: 'My Pre-diabetes Journey',
      post: 'I have always seen myself as a health-conscious person and a major part of what I categorized as being “health-conscious” was eating a lot of fruits to ensure I gained my required daily nutrients. In my mind, eating lots of fruits was a win-win because I enjoy the tastes of different fruits and knew I was contributing to my overall health and well-being. In a day, I could eat up to six oranges during breakfast, some grapes and apple and pineapple slices during lunch, and a strawberry banana smoothie in the evening. At the time, I was not aware of the high sucrose, fructose and glucose found in most fruits nor was I aware of the glycemic index assigned to each fruit I consumed. Essentially, while eating fruits is generally good for us, it can become detrimental if not done in moderation, especially for a fifty-year-old who was not very active. It wasn’t until my annual physical exam showed a Hemoglobin A1C (HbA1C) test result of 5.8% that my doctor advised I changed my diet and lifestyle. For context, the HbA1C test is a routine test to determine your blood glucose (sugar) levels at a given point in time. The average adult will receive a result of less than or equal to 5.6% - this is considered the normal range. At 5.8%, I was considered an early stage pre-diabetic. It shocked me to my core and I could not believe that doing the right thing by eating fruits had led me to this point. My doctor recommended some books and diet and lifestyle changes, but my goal was crystal clear - I was not going to be a diabetic by my own doing. I aggressively cut off carbs, red meat and sugars but instead of my A1C level coming down, it grew to 6.3 by my next physical. At this point, I was truly pre-diabetic and extremely worried for my health. Seeing the look of disappointment on my face, my doctor encouraged me by telling me about his own journey from being pre-diabetic to normal. He advised that I aim to lose 5 percent of my total body weight through exercise and diet changes. “Daily exercise that caused me to sweat was my secret, “he said, “If not, the alternative is to be on medication for the rest of your life. Which would you rather have?” The fear of being on medication for life with numerous side effects was the push I needed to take my health back. It took two long years of purposeful living in terms of my diet and lifestyle to finally achieve the results I aimed for and I am happy to beat the drums in victory!!! Because I know a lot of people are struggling with weight-loss or weight “maintenance” and maintaining a healthy diet and lifestyle, I have decided to share the simple diet and lifestyle changes that helped me go from pre-diabetic back to normal. With respect to exercise, I exercised for a minimum of one hour every morning. It is interesting to note that I did all the exercises inside my home (walking around the living rooms and bedrooms, walking up and down the stairs, and dancing to my favorite songs). It was difficult at first, but the most important part of developing a routine is just doing it. Also,  I find that I usually exercise before breakfast because it is difficult for me to exercise after a meal. However, exercising after breakfast works for some people - the important thing is to exercise! Since I started, I have lost almost 10kg, which is above my target of losing 5 percent of my overall weight. Regarding my diet, I cut off all foods and drinks that were hard for me to have in reasonable portions, especially my favorites such as white/wheat bread, breakfast cereals and cakes. Even my favorite drink, Sprite! Now I drink a lot of water… a whole lot of water!',
      date: 'November 26th, 2021',
      tags: [
         {id: 1, label: 'cooking'},
         {id: 2, label: 'dessert'},
         {id: 3, label: 'restaurant'},
      ],
   },
];

export const comments = [
   {
      id: 1,
      img: commentUserImg,
      name: 'Anifowoshe Jennifer',
      date: 'October 4th, 2018',
      time: '4:30pm',
      star: 4.5,
      comment: 'Promote your business achievements with amazing Instagram feed to impress your clients.',
   },
   {
      id: 2,
      img: commentUserImg,
      name: 'Anifowoshe Jennifer',
      date: 'October 4th, 2018',
      time: '4:30pm',
      star: 4.5,
      comment: 'Promote your business achievements with amazing Instagram feed to impress your clients.',
   },
   {
      id: 3,
      img: commentUserImg,
      name: 'Anifowoshe Jennifer',
      date: 'October 4th, 2018',
      time: '4:30pm',
      star: 4.5,
      comment: 'Promote your business achievements with amazing Instagram feed to impress your clients.',
   },
   {
      id: 4,
      img: commentUserImg,
      name: 'Anifowoshe Jennifer',
      date: 'October 4th, 2018',
      time: '4:30pm',
      star: 4.5,
      comment: 'Promote your business achievements with amazing Instagram feed to impress your clients.',
   },
];

export const cartItem = [
   {
      id: 1,
      img: popular3,
      desc: 'LTH breakfast with two eggs, two waffles two pancakes & Bacon sausages',
      mealType: 'Breakfast Meal',
      price: '5,500',
   },
   // {
   //    id: 2,
   //    img: bMeal,
   //    desc: 'LTH breakfast with two eggs, two waffles two pancakes & Bacon sausages',
   //    mealType: 'Breakfast Meal',
   //    price: '5,500',
   // },
];
